import { Col, Row, View } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import IconCheckCircleFillSmall from "@amzn/stencil-react-icons/icons/icon-check-circle-fill-small";
import IconCloseCircleFillSmall from "@amzn/stencil-react-icons/icons/icon-close-circle-fill-small";
import React from "react";
import { FormattedMessage } from "react-intl";

import { BulletList } from "@/components/Commons/BulletList";
import { StepBodyStyledText } from "@/components/Commons/StepBodyStyledText";
import { ITS_LIGHT_TEAL } from "@/components/constants";

/**
 * isGesture is used to determine whether or not to show the Don't bullet point about covering the id.
 * If it is a gesture video recording, the line is not needed.
 */
type DosDontsProps = {
  isIdPresent?: boolean;
};

/**
 * General Don'ts hints that don't include mention of ID
 */
const DONT_HINTS_GENERAL = [
  "identityCheck-dont-hint2",
  "identityCheck-dont-hint3",
  "identityCheck-dont-hint4",
];
/**
 * Don'ts hints with mentions of ID
 */
const DONT_HINTS_WITH_ID = ["identityCheck-dont-hint1", ...DONT_HINTS_GENERAL];

/**
 * Render a view that tells NHs what they should and should not do.
 */
export default function DosDonts({ isIdPresent }: DosDontsProps): JSX.Element {
  const dosI18nIds = ["identityCheck-do-hint1", "identityCheck-do-hint2"];
  const dontsI18nIds = isIdPresent ? DONT_HINTS_WITH_ID : DONT_HINTS_GENERAL;

  return (
    <View backgroundColor={ITS_LIGHT_TEAL} padding="S400">
      <Row justifyContent="space-evenly">
        <Col dataTestId="dosCol">
          <Row gridGap="S300" dataTestId="dosTitleRow">
            <IconCheckCircleFillSmall
              color="green70"
              margin={{ top: "2px" }}
              aria-hidden
            />
            <StepBodyStyledText>
              <Text fontWeight="bold">
                <FormattedMessage id="identityCheck-do-title" />
              </Text>
            </StepBodyStyledText>
          </Row>
          <BulletList i18nIds={dosI18nIds} dataTestId="dosList" />
        </Col>
        <Col dataTestId="dontsCol">
          <Row gridGap="S300" dataTestId="dontsTitleRow">
            <IconCloseCircleFillSmall
              color="red70"
              margin={{ top: "2px" }}
              aria-hidden
            />
            <StepBodyStyledText>
              <Text fontWeight="bold">
                <FormattedMessage id="identityCheck-dont-title" />
              </Text>
            </StepBodyStyledText>
          </Row>
          <StepBodyStyledText>
            <BulletList i18nIds={dontsI18nIds} dataTestId="dontsList" />
          </StepBodyStyledText>
        </Col>
      </Row>
    </View>
  );
}
